import React from 'react';
import { MessageSquare, WifiOff, Lock, Sliders, Eye, Palette } from 'lucide-react';

const Features = () => {
  const featureList = [
    {
      Icon: Eye,
      title: 'On-Device Vision AI (v3.0.0)',
      desc: 'Analyze images, read OCR text, and answer visual questions locally using SmolVLM 256M — runs smoothly on 1 GB RAM (365 MB download).'
    },
    {
      Icon: Palette,
      title: 'Appearance Customizer (v3.0.0)',
      desc: 'Customize user bubble colors and send button accents with tactile spring-animated swatches and live header preview dots.'
    },
    {
      Icon: Sliders,
      title: 'Inline Reasoning Controls',
      desc: 'Seamlessly expand reasoning effort levels (Light, Medium, High, Ultra) and Fast Chat mode with buttery animations inside the composer.'
    },
    {
      Icon: WifiOff,
      title: 'Runs 100% Offline',
      desc: 'No API keys, server delays, or network queries. Complete inference is handled directly on your local device CPU.'
    },
    {
      Icon: Lock,
      title: 'Zero Data Leaks',
      desc: 'Your chat history, preferences, user profile name, and assistant memories stay strictly stored inside secure local AsyncStorage.'
    },
    {
      Icon: MessageSquare,
      title: 'Fluid Text & Thought Streaming',
      desc: 'Buttery-smooth text streaming equipped with user-aware auto-scrolling, Markdown code rendering, and live thought timers.'
    }
  ];

  return (
    <section id="features" className="features-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Engineered for On-Device Control</h2>
          <p className="section-subtitle">
            Experience advanced AI execution designed with total privacy, responsiveness, and control in Rivo v3.0.0.
          </p>
        </div>
        <div className="features-grid">
          {featureList.map((feat, index) => {
            const Icon = feat.Icon;
            return (
              <div key={index} className="feature-card">
                <div className="feature-icon-wrapper">
                  <Icon size={24} strokeWidth={2.2} className="feature-icon" />
                </div>
                <h3 className="feature-card-title">{feat.title}</h3>
                <p className="feature-card-desc">{feat.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
